const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_da_part2 = {
  handoverRequiredRate: "Kræver kundeservice",
  fallbackRate: "Fallback rate",
  userRequestedCustomerServiceRate: "Bruger bad om kundeservice",
  resolutionCategoryFilterApplied: "Viser samtaler med",
  ligegyldigRate: "Ligegyldig rate",
  lackingInfoRate: "Manglende info rate",

  // Export conversations translations

  // Export conversations translations
  exportConversations: "Eksporter Samtaler",
  exportConversationsTitle: "Eksporter Samtaler",
  exportCenterTitle: "Eksport Center",
  rawConversationsExport: "Rå samtaler",
  statisticsExport: "Statistik",
  exportFormat: "Format",
  runExport: "Kør eksport",
  includeChatbotId: "Inkluder chatbot id",
  conversationDataMessageTypes: "Samtaledata beskedtyper",
  statisticsMode: "Statistiktilstand",
  statisticsBreakdowns: "Opdelinger",
  summaryFields: "Opsummeringsfelter",
  conversationDetails: "Samtaledetaljer",
  exportTemplateName: "Skabelonnavn",
  saveTemplate: "Gem skabelon",
  loadTemplate: "Indlæs skabelon",
  updateTemplate: "Opdater skabelon",
  templateSaved: "Skabelon gemt",
  templateUpdated: "Skabelon opdateret",
  templateDeleted: "Skabelon slettet",
  templateName: "Skabelonnavn",
  templateNamePlaceholder: "Skabelonnavn",
  selectTemplate: "Vælg skabelon",
  exportTemplates: "Eksportskabeloner",
  savedTemplates: "Gemte skabeloner",
  saveAsTemplate: "Gem som skabelon",
  deleteTemplate: "Slet skabelon",
  confirmDeleteTemplate: "Slet denne skabelon? Dette kan ikke fortrydes.",
  noTemplatesSaved: "Ingen gemte skabeloner endnu",
  scheduleReport: "Planlæg rapport",
  scheduleReports: "Planlæg rapporter",
  recipientEmails: "Modtager emails",
  recipientEmailsHelp: "Adskil flere emailadresser med komma",
  scheduleRecipients: "Modtagere",
  scheduleRecipientsPlaceholder: "email@eksempel.dk",
  scheduleFrequency: "Frekvens",
  daily: "Daglig",
  weekly: "Ugentlig",
  monthly: "Månedlig",
  weekday: "Ugedag",
  scheduleWeekdayMonday: "Mandag",
  scheduleWeekdayTuesday: "Tirsdag",
  scheduleWeekdayWednesday: "Onsdag",
  scheduleWeekdayThursday: "Torsdag",
  scheduleWeekdayFriday: "Fredag",
  scheduleWeekdaySaturday: "Lørdag",
  scheduleWeekdaySunday: "Søndag",
  dayOfMonth: "Dag i måneden",
  [duplicateTranslationKey("timeOfDay")]: "Tidspunkt",
  scheduleTimeOfDay: "Tidspunkt",
  scheduleCreated: "Rapportplan gemt",
  scheduleDeleted: "Rapportplan slettet",
  deleteSchedule: "Slet plan",
  createSchedule: "Opret plan",
  scheduleRequiresTemplate: "Gem eller indlæs en skabelon før planlægning.",
  saveTemplateBeforeScheduling: "Gem eller vælg en skabelon før planlægning",
  breakdownPerChatbot: "Opdeling per chatbot",
  breakdownPerCategory: "Opdeling per kategori",
  includeConversationDetails: "Inkluder samtaledetaljer",
  includeUserMessages: "Inkluder brugermeddelelser",
  includeAiMessages: "Inkluder AI-meddelelser",
  includeSystemMessages: "Inkluder systemmeddelelser",
  includeMetricSummary: "Inkluder metrics",
  scheduleSectionTitle: "Email-plan",
  templatesSectionTitle: "Skabeloner",
  settingsUpdatedForNewOptions: "Skabelon opdateret med nye standardindstillinger",
  exportTemplateCompatibilityNotice:
    "Skabelonen blev opdateret med nye standardindstillinger. Gennemse den før eksport.",
  selectExportTimePeriod: "Vælg tidsperiode for eksporten",
  exportCustomRangeRequired: "Vælg både start- og slutdato for en brugerdefineret eksport.",
  exporting: "Eksporterer...",
  exportToCsv: "Eksporter til CSV",
  exportToXlsx: "Eksporter til XLSX",
  exportSuccess: "Samtaler eksporteret",
  exportError: "Kunne ikke eksportere samtaler. Prøv igen.",
  exportGeneratedSuccess: "Eksport genereret",
  exportTemplatesLoadError: "Kunne ikke indlæse eksportskabeloner",
  exportFailed: "Eksport mislykkedes",
  authTokenMissing: "Godkendelsestoken mangler",
  noConversationsFound: "Ingen samtaler fundet for de valgte kriterier",
  splitByChatbotId: "Opdel efter Chatbot ID",

  // Settings translations

  // Settings translations
  notifications: "Notifikationer",
  settingsButton: "Indstillinger",
  statisticsSettings: "Statistik Indstillinger",
  statisticsVisibility: "Statistik Synlighed",
  statisticsVisibilityDescription:
    "Vælg hvilke statistikker der skal vises på hovedstatistiksiden. Ændringer gemmes automatisk.",
  aiStatistics: "AI Statistikker",
  // Topics management (Emner)
  // Topics management (Emner)
  conversations: "samtaler",
  topicsManagementTitle: "Emner",
  topicsManagementDescription:
    "Administrér de emner AI'en bruger til at kategorisere samtaler. Beskrivelsen guider AI'ens klassificering.",
  topicsSelectSingleChatbot: "Vælg en enkelt chatbot for at administrere emner.",
  topicsInheritedBanner: "Emnerne nedarves fra den overordnede chatbot.",
  topicsCustomize: "Tilpas",
  topicsCustomized: "Emnerne er nu kopieret og kan tilpasses.",
  topicsLoadError: "Kunne ikke indlæse emner",
  topicName: "Navn",
  topicDescriptionLabel: "Beskrivelse",
  topicDescriptionHint: "Tilføj beskrivelse...",
  topicAdd: "Tilføj emne",
  topicNewNamePlaceholder: "Nyt emne...",
  topicNewDescriptionPlaceholder: "Beskrivelse (valgfri)",
  topicCreated: "Emne oprettet",
  topicDeleted: "Emne slettet",
  topicDelete: "Slet emne",
  topicArchivedBadge: "Arkiveret",
  topicMergeExplanation: "Vælg hvilket emne samtalerne skal flyttes til – derefter slettes emnet.",
};
